import { useMemo } from 'react'
import { ReactComponent as DefaultStudentsIcon } from 'assets/icons/student-candidates/student-8240817.svg'
import { ReactComponent as HomeIcon } from 'assets/icons/sidebar/home.svg'
import { ReactComponent as CurriculumIcon } from 'assets/icons/sidebar/dumbbell.svg'
import { ReactComponent as ApplicationsIcon } from 'assets/icons/sidebar/calendar.svg'
import { ReactComponent as MessagesIcon } from 'assets/icons/sidebar/messages.svg'
import { ReactComponent as ResearchIcon } from 'assets/icons/travel_explore.svg'
import { ROUTES } from 'shared/config/routes'
import { prioritySummaryStore } from 'shared/stores/prioritySummaryStore'

export const useMainNavItems = ({
	applicationsLabel = 'Applications',
	StudentsIcon = DefaultStudentsIcon,
} = {}) => {
	const assignmentBadgeText = prioritySummaryStore.notificationAssignmentsBadgeText
	const applicationsBadgeText = prioritySummaryStore.notificationApplicationsBadgeText
	const messagesBadgeText = prioritySummaryStore.notificationMessagesBadgeText

	return useMemo(
		() => [
			{ to: '/', icon: <HomeIcon />, label: 'Home' },
			{
				to: '/students',
				icon: <StudentsIcon />,
				label: 'Students',
				iconClass: 'studentNavIcon',
			},
			{
				to: '/applications',
				icon: <ApplicationsIcon />,
				label: applicationsLabel,
				iconClass: 'compactNavIcon',
				badgeText: applicationsBadgeText,
				end: true,
			},
			{
				to: '/curriculum',
				icon: <CurriculumIcon />,
				label: 'Curriculum',
				iconClass: 'compactNavIcon',
				badgeText: assignmentBadgeText,
			},
			{ to: ROUTES.RESEARCH, icon: <ResearchIcon />, label: 'Explore' },
			{
				to: ROUTES.MESSAGES,
				icon: <MessagesIcon />,
				label: 'Messages',
				iconClass: 'compactNavIcon',
				badgeText: messagesBadgeText,
			},
		],
		[
			assignmentBadgeText,
			applicationsBadgeText,
			messagesBadgeText,
			applicationsLabel,
		],
	)
}
